

module.exports = __webpack_require__.stylable.create(
    "o6",
    {"classes":{"consolePointer":"s5","consoleLog":"s6","consoleLogContent":"s7","user":"s8","root":"s9"},"vars":{},"stVars":{},"keyframes":{"pointerFade":"o6__pointerFade"}},
    "",
    1,
    6,
    null
);

